<template>
  <div class="share-container">
    <div class="act-price">
      <div class="price-item">
        <span class="item-label">订单商品总金额</span>
        <span class="item-value">{{detail.goodsAmount | amount}}元</span>
      </div>
      <div class="price-item">
        <span class="item-label">应付金额</span>
        <span class="item-value" style="color: #FF2E2E;">{{detail.amount | amount}}元</span>
      </div>
      <div class="price-item" v-if="detail.fixedTotalPrice">
        <span class="item-label">固定价格活动</span>
        <span class="item-value">-{{detail.fixedTotalPrice | regDecimalPoint }}元</span>
      </div>
      <div class="price-item" v-if="detail.fullTotalPrice">
        <span class="item-label">满减活动</span>
        <span class="item-value">-{{detail.fullTotalPrice | regDecimalPoint }}元</span>
      </div>
      <!-- <div class="price-item" v-if="detail.totalStaffAdjustPriceDiscount !== 0">
        <span class="item-label">人工改价</span>
        <span class="item-value">{{detail.totalStaffAdjustPriceDiscount > 0 ? '+' : ''}}{{detail.totalStaffAdjustPriceDiscount | amount}}元</span>
      </div> -->
    </div>
    <div class="real-price">
      <div class="price-info">
        <div class="total-price">
          <span class="label">商品总金额：</span>
          <span class="value">￥{{detail.amount | amount}}</span>
        </div>
        <div class="discount-price">折扣 
          <!-- {{
            (detail.promotionAmount + (0-(detail.totalStaffAdjustPriceDiscount / 1))) <= 0 ? '+' : '-'
          }}￥{{Math.abs(detail.promotionAmount + (0-(detail.totalStaffAdjustPriceDiscount / 1))) | amount}} -->
          -￥{{Math.abs(detail.promotionAmount) | amount}}
        </div>
      </div>
      <div class="submit-btn" v-if="!isDisabled" @click="clickHandler">提交订单</div>
      <div class="submit-btn disabled" v-else>已提交</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async clickHandler() {
      await this.$confirm('是否提交该订单', '', {
        customClass: '_share-message-box'
      })
      this.$emit('confirm')
    }
  }
}
</script>

<style>
._share-message-box {
  width: 280px;
}
</style>

<style lang="scss" scoped>
.share-container {
  background-color: #fff;
  padding-bottom: 6.6vh;
  .act-price {
    padding: 1.8vh 8vw 1.5vh;
    border-bottom: 1px solid #f0f0f0;
    .price-item {
      font-size: 14px;
      padding: 0.75vh 0;
      display: flex;
      justify-content: space-between;
      .item-label {
        color: rgba(#1d2c36, 0.5);
      }
    }
  }
  .real-price {
    height: 6.6vh;
    width: 100vw;
    padding-left: 4vw;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    background-color: #fff;
    .price-info {
      font-size: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #ff2e2e;
      .total-price {
        .label {
          color: rgba(#1d2c36, 0.5);
        }
        .value {
          font-size: 14px;
        }
      }
    }
    .submit-btn {
      height: 100%;
      width: 30vw;
      line-height: 6.6vh;
      font-size: 16px;
      color: #fff;
      background: linear-gradient(135deg, #014492 0%, #6ec8e2 100%);
      text-align: center;
    }
    .submit-btn.disabled {
      background: #cccccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/share/confirm-order/components/OrderFooter.vue